import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { BrowserRouter } from "react-router";
import "./App.css";
import { OrganizationAccessSync } from "./components/OrganizationAccessSync";
import { ErrorBoundary } from "./error/ErrorBoundary";
import RoutesComponent from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (err) => {
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 401 || err.response?.status === 403) {
          Cookies.remove("token");
          Cookies.remove("fp_access_token");
          window.location.href = "/";
          // push('');
        }
      }
    },
  }),
  queryCache: new QueryCache({
    onError: (err) => {
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 401 || err.response?.status === 403) {
          Cookies.remove("token");
          Cookies.remove("fp_access_token");
          window.location.href = "/";
          // push('');
        }
      }
    },
  }),
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        {/* <SettingProvider> */}
        <BrowserRouter>
          <OrganizationAccessSync />
          <RoutesComponent />
        </BrowserRouter>
        {/* </SettingProvider> */}
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
